import { SnLonLatLike } from '@lib/geo/helpers';

export interface IBaseMarkerOptions {
  id?: string;
  title?: string;
  lonLat?: SnLonLatLike;
}
